export const DRAWER_TYPES = {
  CallList: 'CallList',
  ConvertSendoverToSendout: 'ConvertSendoverToSendout',
  CreateCall: 'CreateCall',
  CreateSendoutInterview: 'CreateSendoutInterview',
  CreateSendout: 'CreateSendout',
  CreateSendover: 'CreateSendover',
  Duplicates: 'Duplicates',
  SendoutDeclinationReasons: 'SendoutDeclinationReasons',
  SendoutDetails: 'SendoutDetails',
  SendoutDetailsEdit: 'SendoutDetailsEdit',
  SendoutInterviewDetails: 'SendoutInterviewDetails',
  SendoverDeclinationReasons: 'SendoverDeclinationReasons',
  SendoverDetails: 'SendoverDetails'
};
